module.exports = __webpack_public_path__ + "static/media/appy-here.1ec689b9.png";